<template>
  <v-data-table
    :headers="headers"
    :items="itemsRep"
    item-key="key"
    sort-by="Articulo"
    group-by="CodSeccion"
    class="elevation-1"
    show-group-by
    hide-default-footer
    disable-pagination
    :custom-filter="filterArt"
    :search="search"
    
  >
    <template v-slot:top>
      <div class="text-left">
        <v-text-field
          v-model="search"
          color="accent"
          hide-details
          class="mx-3"
          dense
          filled
          single-line
          clear-icon="mdi-close-circle"
          clearable
          label="Buscar Repuesto"
          type="text"
          append-icon="mdi-magnify"
        ></v-text-field>
      </div>
    </template>

    <template v-slot:[`item.Precio`]="{ item }">
      {{
        dataUser.VerPrecios[tipoMoneda] === true
          ? simboloMoneda[tipoMoneda]
          : ""
      }}
      {{ dataUser.VerPrecios[tipoMoneda] ? item.Precio[tipoMoneda] : "" }}
    </template>
    <template v-slot:[`item.Disponible`]="{ item }">
      {{ dataUser.IndAutenticado ? item.Disponible : "" }}
    </template>

    <template v-slot:[`item.Articulo`]="{ item }">
      <span @click="articuloRoute(item.Articulo)" style="cursor: pointer">
        {{ item.Articulo }}
      </span>
    </template>

    <template
      v-slot:[`group.header`]="{ items, group, headers, toggle, isOpen }"
    >
      <td :colspan="headers.length">
        <v-btn @click="toggle" x-small icon :ref="group">
          <v-icon v-if="isOpen">mdi-minus</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
        <span style="color: #4d6572" class="mx-6 font-weight-bold">
          {{
            items
              .filter((x) => x.CodSeccion === group)
              .map((x) => x.NombreSec)[0]
          }}
        </span>
      </td>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <btnAdd
        class="ml-2"
        :selcliente="Cliente.showOpc"
        :userAuth="dataUser.IndAutenticado"
        :codArt="item.Articulo"
        :promo="false"
        color="transparent"
        @promoArticulo="0"
        :tipoConsulta="1"
        :ver="true"
        :textbtn="``"
      />
    </template>
  </v-data-table>
</template>
<script>

import { mapState} from "vuex";
import btnAdd from "../components/botonadd"
export default {
  name: "Verrep",
  components:{
    btnAdd
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Codigo",
          value: "Articulo",
          align: "left",
          groupable: false,
          sortable: false,
          divider: true,
          width: "15%",
        },
        {
          text: "Nombre",
          align: "start",
          value: "NombreArt",
          groupable: false,
          width: "30%",
          sortable: false,
          divider: true,
        },
        {
          width: "10%",
          text: "Usa",
          value: "Cantidad",
          align: "center",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "Stock",
          width: "10%",
          value: "Disponible",
          align: "right",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "Precio",
          value: "Precio",
           width: "10%",
          align: "right",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "",
          class: "primary--text text--darken-2 body-2 font-weight-bold",
          value: "actions",
          sortable: false,
          width: "10%",
          align: "center",
          groupable: false,
        }, 
      ],
    };
  },
  props: {
    datosRepuestos: Array,
    tipovista: Number,
  },
  methods: {
    filterArt(value, search, item) {
      let txt = `${item.Articulo} ${item.NombreArt}`;

      return (
        value != null &&
        search != null &&
        txt.toLowerCase().includes(search.toLowerCase())
      );
    },
    articuloRoute(codart) {
      window.scrollTo(0, 0);
      if (codart != this.codArticulo)
        return this.$router.push("/articulo/" + codart);
    },
  },
  computed: {
    ...mapState(["tipoMoneda", "simboloMoneda", "dataUser", "Cliente"]),
    itemsRep() {
      let xData = [];
      if (Object.entries(this.fichaEncab2).length !== 0) {
        this.fichaEncab2.map((item) => {
          this.datosRepuestos.map((rep) => {
            if (rep.CodSeccion === item.CodSeccion) xData.push(rep);
          });
        });
      }
      return xData.map((item, key) => ({ ...item, key }));
    },
    fichaContenido: function () {
      return function (id) {
        return this.datosRepuestos.filter((x) => x.CodSeccion === id);
      };
    },
    codArticulo: {
      get: function () {
        return this.$route.params.codart;
      },
    },
    fichaEncab2() {
      if (this.datosRepuestos) {
        return this.datosRepuestos.filter(
          (v, i, a) => a.findIndex((t) => t.CodSeccion === v.CodSeccion) === i
        );
      }
      return true;
    },
  },
};
</script>

<style></style>
